const StockVariation = () => import(/* webpackChunkName: "stockVariation" */ './StockVariation.vue')

const index = {
  path: 'stock/variation',
  name: 'Stock Variation',
  component: StockVariation,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

export default {
  index
}
